if (!customElements.get("recently-seen-list")) {
  class RecentlySeenList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.loadFavoritesList();
    }

    async loadFavoritesList() {
      const recentlySeenHandles = RecentlySeen.getAll();
      // Array of handles
      const results_list = document.querySelector(".recently_seen_list");
      const results_wrapper = document.querySelector(".recently_seen_wrapper");

      if (recentlySeenHandles.length === 0) {
        results_wrapper.style.display = "none";
        return;
      }

      for (const productHandle of recentlySeenHandles) {
        try {
          const response = await fetch(`/products/${productHandle}?section_id=recently-seen-renderer`);
          const html = await response.text();
          // Dom parser the html
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const product = doc.querySelector("product-card");

          results_list.appendChild(product);
        } catch (error) {
          console.error("Error loading product:", productHandle, error);
        }
      }
    }
  }
  customElements.define("recently-seen-list", RecentlySeenList);
}
